site.mMenu = {
	init: function() {
		var $mMenu = $('#mainmenu').find('.contentWrap').clone().prop('id', 'mMenu').attr('role','navigation'),
			$body = $('body');
		$body.append($mMenu);
		var $mHeader = $('#header').clone().prop('id', 'mHeader').addClass('Fixed');
		$body.append($mHeader);

		var $navbar = $('.miniCart', '#qn').clone();

		$('#mMenu').mmenu({
			// options
			offCanvas: {
				position: "right"
			},
			extensions: ["theme-moya"],
			navbars: [{
				position: "top",
				content: $navbar
			}]
		},{
			// configuration
			classNames: {
				selected:"active"
			}
		});

		var API = $("#mMenu").data( "mmenu" );

		$("#mainmenuToggle").click(function() {
			API.close();
		});

		var $mSearch = $('#searchForm').clone().prop('id','mSearchForm');
		$('.mm-panel:first-child .mm-navbar','#mMenu').append($mSearch);

		$('#mMenu .mm-next').append('<span class="sr-only">Next</span>');
		$('#mMenu .mm-btn.mm-prev').append('<span class="sr-only">Prev</span>');
		$('#mSearchForm label').remove();
	}
};

site.inits.push('site.mMenu.init()');
